<script setup>
const props = defineProps({
  eligibility: {
    type: Object,
  },
  event: {
    type: Object,
  },
})

const { t } = useI18n()
const { r } = useRoutes()

const selectedCustomer = useSelectedCustomer()

function beginReservation() {
  window.location.href = r({
    path: `/reservation/subscribe/router?customer=${selectedCustomer.value}&event=${props.event?.id}`,
    isV2Path: false,
  })
}
</script>

<template>
  <div class="flex flex-col items-center flex-gap-y-2">
    <p class="text-text-500 fw-600">
      {{ t('or') }}
    </p>
    <div class="w-full">
      <DSButton
        class="btn btn-md w-full flex items-center justify-center flex-gap-2 truncate btn-fill-secondary"
        @click="beginReservation()"
      >
        <DSTooltip
          variant="light-bordered"
        >
          <DSIcon
            icon="i-far-circle-info"
            size="16"
            class="text-text-100"
          />
          <template #content>
            <p class="rounded bg-secondary-100 px-4 py-2 text-wrap text-xs">
              {{ t('A reservation will book you into the same class on a recurring basis for as long as your membership allows it.') }}
            </p>
          </template>
        </DSTooltip>
        <span class="truncate uppercase">{{ t('Begin a New Reservation') }}</span>
      </DSButton>
    </div>
  </div>
</template>

<i18n>
{
  "en-us": {
    "or": "or",
    "Begin a New Reservation": "Begin a New Reservation",
    "A reservation will book you into the same class on a recurring basis for as long as your membership allows it.": "A reservation will book you into the same class on a recurring basis for as long as your membership allows it."
  }
}
</i18n>

<!-- <style scoped lang="scss">
:deep([data-ds-component='tooltip'] > button) {
  @apply min-w-full;
}
</style> -->

<i18n locale="de" lang="json">
{
  "or": "oder",
  "Begin a New Reservation": "Eine neue Reservierung starten",
  "A reservation will book you into the same class on a recurring basis for as long as your membership allows it.": "Eine Reservierung bucht Sie immer wieder in denselben Kurs, solange Ihre Mitgliedschaft dies zulässt."
}
</i18n>

<i18n locale="fr" lang="json">
{
  "or": "ou",
  "Begin a New Reservation": "Commencer une nouvelle réservation",
  "A reservation will book you into the same class on a recurring basis for as long as your membership allows it.": "Une réservation vous inscrit au même cours de manière récurrente, aussi longtemps que votre abonnement le permet."
}
</i18n>

<i18n locale="es" lang="json">
{
  "or": "o",
  "Begin a New Reservation": "Empezar una reserva nueva",
  "A reservation will book you into the same class on a recurring basis for as long as your membership allows it.": "La reserva le inscribirá en la misma clase de manera recurrente durante el tiempo que permita su suscripción."
}
</i18n>
